import { isValidSession } from '../../services/session';

export const shouldRenderHeader = ({ isAuthenticated, pathname }) =>
  Boolean(isAuthenticated) && typeof pathname === 'string' && pathname !== '' && pathname !== '/';

export const authFromStoredSession = (stored) => {
  if (!isValidSession(stored)) {
    return { isAuthenticated: false, userRole: null };
  }
  return { isAuthenticated: true, userRole: stored.user.role };
};

